<template>
<div>
<!-- <div class="hero-about bg-alt h-500"></div> -->
    <div class="py-md-3 py-lg-5 px-xl-6 px-4">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 push-40 pt-10">
                    <h3 class="mb-5">About Us</h3>
                </div>

                <div class="col-12 col-md-10 offset-md-1 push-40">
                    <p>Home Solutions is an established, Canberra based design company. We service Canberra and the whole surrounding area including Googong, Queanbeyan, Captains Flat, Bungendore and Murrumbateman.</p>

                    <p>Our team has extensive experience in New Homes, Extensions, Renovations and Multi-residential projects. We pride ourselves on delivering high quality design and documentation services.</p>

                    <p>Our commitment to customer satisfaction means much of our work is repeat business from satisfied clients.</p>

                    <p>Our unique relationship with multiple manufacturing companies and building suppliers gives us direct access to construction details and the latest building products.</p>

                    <p>At Home Solutions Design Group, it is important for us to produce each product with emphasis on innovative design, sustainability and ultimately, client value.</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Logos from './misc/Logos'
export default {
	name: 'about',
	components: { Logos },
	data() {
		return {
			assets: process.env.ASSETS_URL
		}
	},
	head: {
		title: {
			inner:
				'About Home Solutions Design Group | Canberra 3D Drafting | Canberra House Plans'
		},
		meta: [
			{
				name: 'description',
				content:
					'Learn about the history and team at Home Solutions Design Group',
				id: 'desc'
			}
		]
	}
}
</script>


// WEBPACK FOOTER //
// src/components/About.vue